import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a85f47b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "input-wrapper"
};
const _hoisted_2 = ["value", "placeholder"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("input", {
    class: "input",
    value: $props.modelValue,
    onInput: _cache[0] || (_cache[0] = (...args) => $setup.updateInput && $setup.updateInput(...args)),
    type: "text",
    placeholder: $props.placeholder
  }, null, 40, _hoisted_2)]);
}